import { useHostingEnv } from '@/common/env';

interface Options {
  scheme: string
  universalLink?: string
  downloadUrl?: string
  onlyScheme?: boolean // 是否仅用 scheme 进行唤端
  autoDownload?: boolean // 唤端失败 是否自动跳转到下载页
}

export const openApp = (options: Options) => {
  const {
    scheme = 'bstar://home',
    universalLink = 'https://www.bilibili.tv/',
    downloadUrl = 'https://www.bilibili.tv/download',
    onlyScheme = false,
    autoDownload = true
  } = options;
  const { isiOS, isInApp } = useHostingEnv();
  const appLink = onlyScheme ? scheme : isiOS ? universalLink : scheme;

  if (isInApp) {
    document.location.href = scheme;
    return;
  }

  openAppLink(autoDownload, appLink, downloadUrl);
};

function openAppLink (autoDownload: boolean, redirectLink: string, downloadLink: string) {
  if (!redirectLink) return;

  if (autoDownload && downloadLink !== '') {
    const hiddenProperty = 'hidden' in document
      ? 'hidden'
      : (
        'webkitHidden' in document
          ? 'webkitHidden'
          : ('mozHidden' in document ? 'mozHidden' : null)
      );
    let timer: NodeJS.Timeout | null = null;
    const clear = () => {
      if (document[hiddenProperty]) {
        timer && clearTimeout(timer);
      }
    };

    document.addEventListener('visibilitychange', clear);

    timer = setTimeout(() => {
      document.removeEventListener('visibilitychange', clear);
      if (!document[hiddenProperty]) {
        document.location.href = downloadLink;
        return false;
      }
    }, 3000);
  }

  document.location.href = redirectLink;
}

export const generateScheme = (roomId: number) => {
  return `bstar://live/${roomId || ''}`;;
};
